import React, { useState } from 'react';

const CITIES = [
  { name: 'São Paulo', lat: -23.5505, lng: -46.6333 },
  { name: 'Rio de Janeiro', lat: -22.9068, lng: -43.1729 },
  { name: 'Brasília', lat: -15.7975, lng: -47.8919 },
  { name: 'Salvador', lat: -12.9714, lng: -38.5124 },
  { name: 'Belo Horizonte', lat: -19.9167, lng: -43.9345 },
  { name: 'Curitiba', lat: -25.4284, lng: -49.2733 },
  { name: 'Campinas', lat: -22.9099, lng: -47.0626 },
  { name: 'Porto Alegre', lat: -30.0346, lng: -51.2177 },
  { name: 'Recife', lat: -8.0476, lng: -34.8770 },
  { name: 'Fortaleza', lat: -3.7172, lng: -38.5433 },
  { name: 'Manaus', lat: -3.1190, lng: -60.0217 },
];

export default function LocationButton({ onRequestLocation, onSetManualLocation, loading, error }) {
  const [showCities, setShowCities] = useState(!!error);

  const isPermissionDenied = error && error.includes('negada');

  return (
    <div className="location-section">
      <button
        className="btn btn-primary"
        onClick={onRequestLocation}
        disabled={loading}
      >
        {loading ? (
          <>
            <span className="spinner-inline" /> Obtendo localização...
          </>
        ) : (
          '📍 Usar minha localização'
        )}
      </button>

      <button
        className="btn btn-secondary"
        onClick={() => setShowCities(!showCities)}
      >
        🏙️ Escolher cidade
      </button>

      {error && (
        <div className="location-error-box">
          <p className="location-error">{error}</p>
          {isPermissionDenied && (
            <p className="location-error-hint">
              💡 Escolha uma cidade abaixo para continuar sem GPS:
            </p>
          )}
        </div>
      )}

      {(showCities || isPermissionDenied) && (
        <div className="city-grid">
          {CITIES.map((city) => (
            <button
              key={city.name}
              className="btn btn-city"
              onClick={() => {
                onSetManualLocation(city.lat, city.lng);
                setShowCities(false);
              }}
            >
              {city.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
